import { render } from "./registro.vue?vue&type=template&id=71db92ce&scoped=true"
import script from "./registro.vue?vue&type=script&lang=js"
export * from "./registro.vue?vue&type=script&lang=js"

import "./registro.vue?vue&type=style&index=0&id=71db92ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71db92ce"]])

export default __exports__